export default function Chip(theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
          fontSize: theme.typography.pxToRem(12),
          height: 24,
        },
        filled: {
          backgroundColor: theme.palette.grey[100],
          color: theme.palette.grey[800],
          '&:hover': { backgroundColor: theme.palette.grey[200] },
        },
        outlined: {
          borderColor: theme.palette.grey[300],
        },
      },
    },
  };
}
